import { Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { palette } from '../../theme/palette';

const StyledMainGrid = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignContent: 'center'
}));

const StyledProfileOption = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '24px 16px 10px',
  gap: '16px',
  cursor: 'pointer'
}));

const StyledProfileCircle = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center'
}));

const StyledProfileTitle = styled(Typography)(() => ({
  fontSize: '22px',
  fontWeight: '600',
  lineHeight: '27px',
  color: '#333'
}));

const StyledProfileSubtitle = styled(Typography)(() => ({
  fontSize: '16px',
  fontWeight: '300',
  lineHeight: '24px',
  color: palette.root.sub
}));

export { StyledMainGrid, StyledProfileOption, StyledProfileCircle, StyledProfileTitle, StyledProfileSubtitle };
